import { AuthenticatedHttpService } from '@/shared/services/HttpService';

export class GroupService extends AuthenticatedHttpService {
  async createGroupInOrganization(organizationId, groupDetails) {
    const httpClient = await this.client();
    const response = await httpClient.post('/group', { organizationId, ...groupDetails });
    return response.data;
  }

  async updateGroupInOrganization(organizationId, groupId, groupDetails) {
    const httpClient = await this.client();
    const response = await httpClient.put(`/group/${groupId}`, { organizationId, ...groupDetails });
    return response.data;
  }

  async client() {
    const baseurl = `${process.env.VUE_APP_BACKEND_URL}/admin`;
    const httpClient = await this.prepareHttpClient(baseurl);

    return httpClient;
  }
}
